<template>
  <el-dialog
    title="新增获奖情况"
    :visible="isAddAwardsDialogShow"
    @open="dialogOpen"
    @close="dialogClose"
    :close-on-click-modal="false"
    width="600px"
  >
    <div class="awardsifno-addawards-form">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="年级班级" label-width="100px" prop="className">
          <el-cascader
            class="student-search"
            v-model="ruleForm.className"
            placeholder="选择"
            :props="classProps"
            :options="classSelect"
            @change="changeHandle"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="学生" label-width="100px" prop="studentId">
          <!-- <el-input
            v-model="ruleForm.studentName"
            autocomplete="off"
            placeholder="请输入姓名"
          ></el-input> -->
          <el-select v-model="ruleForm.studentId" filterable placeholder="请选择学生">
            <el-option
              v-for="item in studentList"
              :key="item.id"
              :label="item.studentName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛名称" label-width="100px" prop="competitionName">
          <el-input
            v-model="ruleForm.competitionName"
            autocomplete="off"
            placeholder="请输入比赛名称"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="获取奖项" label-width="100px" prop="medal">
          <el-input
            v-model="ruleForm.medal"
            autocomplete="off"
            placeholder="请输入获取奖项"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="颁奖单位" label-width="100px" prop="presentationUnit">
          <el-input
            v-model="ruleForm.presentationUnit"
            autocomplete="off"
            placeholder="请输入颁奖单位"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="获奖时间" label-width="100px" prop="gainDate">
          <el-date-picker
            v-model="ruleForm.gainDate"
            type="date"
            placeholder="选择获奖时间"
            value-format="yyyy-MM-dd"
            style="width: 235px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <!-- <el-date-picker
            style="width: 235px"
            v-model="ruleForm.schoolYear"
            type="year"
            placeholder="选择学年"
            @change="schoolYearChangeHandle"
          >
          </el-date-picker> -->
          <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYear" />
        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select
            v-model="ruleForm.semester"
            placeholder="请选择学期"
            style="width: 235px"
          >
            <el-option
              v-for="item in semesterOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="form-btn">
        <!-- <el-button @click="dialogClose">取 消</el-button> -->
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      ruleForm: {
        studentId: "",
        competitionName: "",
        medal: "",
        presentationUnit: "",
        gainDate: "",
        gradeId: "",
        classId: "",
        // 选中后的班级年级
        className: [],
        schoolYear: "",
        semester: "",
      },
      rules: {
        studentId: [{ required: true, message: "请选择学生姓名", trigger: "change" }],
        competitionName: [{ required: true, message: "请输入比赛名称", trigger: "blur" }],
        medal: [{ required: true, message: "请输入获取奖项", trigger: "blur" }],
        presentationUnit: [
          { required: true, message: "请输入颁奖单位", trigger: "blur" },
        ],
        gainDate: [{ required: true, message: "请选择获奖时间", trigger: "change" }],
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
      },
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
    };
  },
  props: {
    isAddAwardsDialogShow: {
      type: Boolean,
      default: false,
    },
    classSelect: {
      type: Array,
    },
    studentList: {
      type: Array,
    },
    semesterOptions: {
      type: Array,
    },
    semester: {
      type: [String, Number],
    },
    schoolYear: {
      type: [String, Number],
    },
  },
  methods: {
    schoolYearChangeHandle(e) {
      // console.log(e);
      // this.ruleForm.schoolYear = e ? "" + e.getFullYear() : "";
    },
    confirm() {
      // console.log("this.ruleForm==>", this.ruleForm);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // this.ruleForm.gradeId = this.classInfo.currentClass.gradeId;
          // this.ruleForm.classId = this.classInfo.currentClass.classId;
          // console.log("this.ruleForm==>", this.ruleForm);
          this.$emit("formSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    // 选择班级
    changeHandle(e) {
      // console.log("选中的班级==>", e);
      if (e) {
        this.$emit("changeClass", e[1].classId);
      }

      // this.ruleForm.gradeId = e[0].gradeId;
      // this.ruleForm.classId = e[1].classId;
    },
    dialogOpen() {
      this.ruleForm = {
        studentId: "",
        competitionName: "",
        medal: "",
        presentationUnit: "",
        gainDate: "",
        gradeId: "",
        classId: "",
        schoolYear: this.schoolYear,
        semester: this.semester,
      };
      this.$emit("changeClass", "");
    },
    dialogClose() {
      this.$emit("update:isAddAwardsDialogShow", false);
    },
    reset() {
      this.ruleForm = {
        studentId: "",
        competitionName: "",
        medal: "",
        presentationUnit: "",
        gainDate: "",
        gradeId: "",
        classId: "",
        semester: "",
        schoolYear: "",
      };
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./addAwards-dialog.scss";
</style>
